<template>
  <div class="pages">
    <component v-bind:is="currentSection" />
    <p id="logo_wrap">
      <router-link :to="{ name: 'home' }">
        <img
          src="@/assets/images/common/logo-footer.jpg"
          width="250"
          alt="onetoone"
          id="one_logo"
        />
      </router-link>
    </p>
    <div id="overlay"></div>
    <div id="lightBoxBg"></div>
    <section id="lightBox">
      <ul class="clearfix">
        <li class="document">
          <img src="" width="100%" alt="" id="detailImages" />
          <div id="detailMessage"></div>
        </li>
      </ul>
      <a href="javascript:void(0);" id="closeBtn">
        <img src="@/assets/images/common/close.png" width="30px" alt="" />
      </a>
    </section>
  </div>
</template>

<script>
import Section1 from '@/components/Section1.vue';
import Section2 from '@/components/Section2.vue';
import Section3 from '@/components/Section3.vue';
import Section4 from '@/components/Section4.vue';
import Section5 from '@/components/Section5.vue';
import Section6 from '@/components/Section6.vue';
import Section7 from '@/components/Section7.vue';
import Section8 from '@/components/Section8.vue';
import Section9 from '@/components/Section9.vue';
import Section10 from '@/components/Section10.vue';
import Section11 from '@/components/Section11.vue';
import Section12 from '@/components/Section12.vue';
import Section13 from '@/components/Section13.vue';
import Section14 from '@/components/Section14.vue';
import Section15 from '@/components/Section15.vue';
import Section16 from '@/components/Section16.vue';
import Section17 from '@/components/Section17.vue';
import Section18 from '@/components/Section18.vue';
import Section19 from '@/components/Section19.vue';
import Section20 from '@/components/Section20.vue';

export default {
  name: 'pages',
  components: {
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
    Section7,
    Section8,
    Section9,
    Section10,
    Section11,
    Section12,
    Section13,
    Section14,
    Section15,
    Section16,
    Section17,
    Section18,
    Section19,
    Section20
  },
  computed: {
    currentSection: function() {
      return 'Section' + this.$route.params.id;
    }
  }
};
</script>
